import { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  onReject: (reason: string) => void;
}

export default function RejectDialog({ open, onClose, onReject }: Props) {
  const [reason, setReason] = useState("");

  const handleReject = () => {
    onReject(reason);
    setReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontFamily: '"Roboto", "Calibri Bold", "Segoe UI", sans-serif',
          fontSize: "1.125rem",
          fontWeight: 700,
          // color inherits from theme.palette.text.primary
          // (= primary-gray-light-900 per ora brand tokens)
        }}
      >
        Reject endorsement plan
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={3}
          label="Rejection reason"
          placeholder="Why is this plan incorrect?"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <button
          type="button"
          onClick={onClose}
          className="btn-tertiary-gray text-sm font-semibold px-3 py-1.5"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleReject}
          disabled={!reason.trim()}
          className="btn-error-secondary text-sm h-10 disabled:opacity-50"
        >
          Reject
        </button>
      </DialogActions>
    </Dialog>
  );
}
